import gql from "graphql-tag";

import CREATE_MESSAGE from "../graphql/chat/CreateMessage.gql";
import CREATE_RECONCILIATION from "../graphql/reconciliation/CreateReconciliation.gql";
import CREATE_RECONCILIATIONS_WITH_SALES_AUTO from "../graphql/reconciliation/CreateReconciliationsWithSalesAuto.gql";
import RECONCILIATION_TYPED_QUERY from "../graphql/reconciliation/ReconciliationTyped.gql";
import UPDATE_NOT_JUSTIFIED_AMOUNT from "../graphql/UpdateBankTransactionNotJustifiedAmount.gql";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";

import { checkIfCloseToZero } from "./mathServices";
import { computeJustifiedNotJustified } from "./bankTransactionServices";
import { computeDebitCredit } from "../../../backend/src/common/accountingLine/accountingLineServices";
import { getConnectAccountableAccount } from "./accountableAccountServices";

const reasons = {
    WITHOUT_INVOICE: "Il n'y a pas de facture pour ce mouvement bancaire",
    SALES_INVOICE_AUTO: "Il s'agit d'un encaissement",
};
//
// WITHOUT INVOICE
//
// function getWithoutInvoiceDocument(companyId, name, withoutInvoiceVAT, grossAmountSigned, date, accountableAccountName) {
//     let document = `{
//             name: "${name}",
//             date: "${date}",
//             type: WITHOUT_INVOICE,`
//     const grossAmount = Math.abs(grossAmountSigned);
//     let netAmount = grossAmount;
//     let netAmountSigned = -grossAmountSigned;
//     if (withoutInvoiceVAT > 0) {
//         document += `vatRate: ${withoutInvoiceVAT},`;

//         netAmount = grossAmount / (1.0 + withoutInvoiceVAT / 100);
//         const vatAmount = grossAmount - netAmount;

//         netAmountSigned = grossAmountSigned > 0 ? -netAmount : netAmount;
//         const vatAmountSigned = grossAmountSigned > 0 ? -vatAmount : vatAmount;

//         document += `vatAmount: ${vatAmount},`;
//         document += `vatAmountSigned: ${vatAmountSigned},`;
//     }
//     const creditNote = grossAmountSigned > 0

//     document += `netAmount: ${netAmount},
//             netAmountSigned: ${netAmountSigned},
//             grossAmount: ${grossAmount},
//             grossAmountSigned: ${grossAmountSigned},
//             status: VALIDATED,
//             company: { connect: { id: "${companyId}" } },
//             accountableAccount: { connect:{ name: "${accountableAccountName}"}},
//             useForReconciliation: false,
//             show: true
//             creditNote: ${creditNote}
//         }`

//     return document
// }

// function createReconciliationWithoutInvoice(companyId, withoutInvoiceVAT, accountableAccount, thirdPartyAccountableAccount, bt) {
//     const date = bt.dateRealization || bt.dateDebit
//     const accountableAccountName = accountableAccount ? accountableAccount.name : "601000";
//     const thirdPartyAccountableAccountName = thirdPartyAccountableAccount ? thirdPartyAccountableAccount.name : "401000";

//     let name = bt.amount > 0 ? "Crédit" : "Débit";
//     const dateString = moment(date).format("DD/MM/YYYY");
//     name += " sans facture du " + dateString;

//     const document = getWithoutInvoiceDocument(companyId, name, withoutInvoiceVAT, bt.amount, date, accountableAccountName);

//     const mutation: string = `reconciliation_${bt.id}: updateBankTransaction(
//         where: {
//             id: "${bt.id}"
//         },
//         data: {
//             accountableAccount: { connect:{ name: "${thirdPartyAccountableAccountName}" }}
//             reconciliation: {create: {
//                 status: VALIDATED
//                 documents: { create: ${document}}
//                 company:{ connect:{ id:"${companyId}" } }
//                 toReplaceDocumentType: WITHOUT_INVOICE
//             }}
//         }
//     ){ id }
//     `;
//     return mutation;
// }

export async function createReconciliationsWithSalesAuto(apollo, companyId, bts, data) {
    const result = await apollo.mutate({
        mutation: CREATE_RECONCILIATIONS_WITH_SALES_AUTO,
        variables: {
            bankTransactionIds: bts.map((bt) => bt.id),
            data: {
                companyId: companyId,
                thirdPartyCompany: data.thirdPartyCompany,
                accountableAccountName: data.accountableAccount.name,
            },
        },
    });
}

export async function linkBankTransactionWithCashBox(apollo, bts) {
    await apollo.mutate({
        mutation: gql`
            mutation ($ids: [ID!]!) {
                linkBankTransactionWithCashBox(data: { bankTransactions: $ids }) {
                    status
                }
            }
        `,
        variables: {
            ids: bts.map((bt) => bt.id),
        },
    });
}

export async function linkBankTransactionAccountingLineWithCashBox(apollo, bt, accountingLine) {
    if (!accountingLine || !accountingLine.id) {
        await linkBankTransactionWithCashBox(apollo, [bt]);
        return;
    }

    await apollo.mutate({
        mutation: gql`
            mutation ($bankTransactionId: ID!, $accountingLineId: ID!) {
                linkBankTransactionAccountingLineWithCashBox(
                    data: {
                        bankTransactionId: $bankTransactionId
                        accountingLineId: $accountingLineId
                    }
                ) {
                    status
                }
            }
        `,
        variables: {
            bankTransactionId: bt.id,
            accountingLineId: accountingLine.id,
        },
    });
}

export async function linkAccountingLineWithCashBox(apollo, companyId, accountingLines) {
    await apollo.mutate({
        mutation: gql`
            mutation ($companyId: ID!, $accountingLines: Json!) {
                linkAccountingLineWithCashBox(
                    data: { companyId: $companyId, accountingLines: $accountingLines }
                ) {
                    status
                }
            }
        `,
        variables: {
            companyId,
            accountingLines,
        },
    });
}

export function getToReconciliateAccountingLines(document) {
    const als = [];
    for (const al of document.accountingLines) {
        if (al.useForReconciliation) {
            als.push(al);
            break;
        }
    }
    return als;
}

export function declareSalesInvoices(company) {
    if (company.taxSystem === "BNC" && isNotSubjectToVAT(company.vatSystem)) return false;
    return true;
}

export async function getReconciliationType(apollo, companyId, reconciliationType, userId) {
    debugger;
    const recResult = await apollo.query({
        query: RECONCILIATION_TYPED_QUERY,
        fetchPolicy: "network-only",
        variables: {
            companyId: companyId,
            type: reconciliationType,
            owner: userId ? { id: userId } : undefined,
        },
    });
    if (
        recResult &&
        recResult.data &&
        recResult.data.reconciliations &&
        recResult.data.reconciliations.length
    ) {
        return recResult.data.reconciliations[0];
    }
    // else {
    //     recResult = await apollo.mutate({
    //         mutation: CREATE_RECONCILIATION_TYPED_QUERY,
    //         variables: {
    //             type: reconciliationType,
    //             status: "EDITION",
    //             companyId: companyId
    //         }
    //     })
    //     if (recResult && recResult.data && recResult.data.createReconciliation) {
    //         return recResult.data.createReconciliation;
    //     }
    // }
    return null;
}

export function getReconciliationCallToActionTitle(
    accountableAccountTable,
    accountingLine,
    company,
    isAccountingUser,
) {
    if (!accountingLine) return "";

    if (accountableAccountTable?.accountableAccounts && accountingLine.accountableAccount?.name) {
        const dbAA = accountableAccountTable.accountableAccounts.find(
            (aa) => aa.name === accountingLine.accountableAccount.name,
        );
        if (!dbAA?.lettering) {
            return "";
        }
    } else {
        debugger;
        return "";
    }

    if (!accountingLine.reconciliation) {
        if (company && company.solution === "MANAGEMENT") {
            return "Trouver le paiement";
        }
        if (isAccountingUser) {
            return "Lettrer";
        }
        return "";
    }
    if (accountingLine.reconciliation.type === "CURRENT_ACCOUNT") return "Voir le(s) règlement(s)";
    if (accountingLine.reconciliation.type === "OPERATOR_ACCOUNT") return "Voir le(s) règlement(s)";
    if (accountingLine.reconciliation.type === "ZTILL_RECEIPT") return "Vérifier le règlement";
    if (accountingLine.reconciliation.type === "CASH_BOX") return "Voir le règlement en espèce";

    if (
        accountingLine.reconciliation.status === "EDITION" ||
        accountingLine.reconciliation.status === "PENDING_VALIDATION_FROM_CLIENT" ||
        accountingLine.reconciliation.status === "PENDING_VALIDATION"
    ) {
        return "Vérifier le règlement";
    }
    if (accountingLine.reconciliation.status === "VALIDATED") {
        return "Voir le règlement";
    }
    debugger;
    return "";
}

export function addThirdParty(accountingLine, toCreateAccountingLine) {
    if (accountingLine) {
        if (accountingLine.thirdPartyCompany) {
            toCreateAccountingLine.thirdPartyCompany = {
                connect: { id: accountingLine.thirdPartyCompany.id },
            };
        }
        if (accountingLine.user) {
            toCreateAccountingLine.user = { connect: { id: accountingLine.user.id } };
        }
        if (accountingLine.bankAccount) {
            toCreateAccountingLine.bankAccount = { connect: { id: accountingLine.bankAccount.id } };
        }
    }
}

export async function reconciliateAlWithBT(
    apollo,
    store,
    userId,
    companyId,
    type,
    bankTransaction,
    btAccountingLine,
    accountingLine,
    reason,
    toReplaceDocumentType: string = undefined,
    updateAccountingLine = undefined,
) {
    if (!accountingLine.accountableAccount?.name) {
        console.error("reconciliateAlWithBT accountableAccount is null");
    }
    const toConnectAccountingLines = [{ id: accountingLine.id }];

    const existingBTAccountingLine = btAccountingLine;

    const toCreateAccountingLines = [];
    if (!existingBTAccountingLine || !existingBTAccountingLine.id) {
        const toCreateAccountingLine = {
            company: { connect: { id: companyId } },
            bankTransaction: null,
            wording: bankTransaction.wordingDisplay || bankTransaction.wordingOriginal,
            date: bankTransaction.dateDebit,
            debit: 0,
            credit: 0,
            amount: Math.abs(accountingLine.amountSigned),
            amountSigned: -accountingLine.amountSigned,
            accountableAccount: await getConnectAccountableAccount(
                store,
                apollo,
                accountingLine.accountableAccount.name,
            ),
        };
        computeDebitCredit(toCreateAccountingLine);
        if (bankTransaction.id) {
            toCreateAccountingLine.bankTransaction = { connect: { id: bankTransaction.id } };
        } else {
            toCreateAccountingLine.bankTransaction = { create: bankTransaction };
        }
        toCreateAccountingLines.push(toCreateAccountingLine);
        bankTransaction.notJustifiedAmountSigned += toCreateAccountingLine.amountSigned;
        computeJustifiedNotJustified(
            bankTransaction.amount,
            bankTransaction.notJustifiedAmountSigned,
            bankTransaction,
        );
        addThirdParty(accountingLine, toCreateAccountingLine);
    } else {
        toConnectAccountingLines.push({ id: existingBTAccountingLine.id });
        bankTransaction.notJustifiedAmountSigned += existingBTAccountingLine.amountSigned;
        bankTransaction.justifiedAmountSigned =
            bankTransaction.amount - bankTransaction.notJustifiedAmountSigned;
    }

    const result = await apollo.mutate({
        mutation: CREATE_RECONCILIATION,
        variables: {
            type: type || "DEFAULT",
            status: "VALIDATED",
            companyId: companyId,
            accountingLines: toConnectAccountingLines,
            toCreateAccountingLines: toCreateAccountingLines,
            toReplaceDocumentType: toReplaceDocumentType,
        },
    });
    if (bankTransaction.id) {
        const data = {};
        await addChatMessageIfNeccessary(apollo, userId, companyId, reason, bankTransaction, data);
        await updateNotJustifiedAmount(apollo, bankTransaction, updateAccountingLine);
    }
    return result;
}

export async function updateNotJustifiedAmount(apollo, bankTransaction, toUpdateAccountingLine) {
    if (bankTransaction) {
        const notJustifiedAmountSigned = checkIfCloseToZero(
            bankTransaction.notJustifiedAmountSigned,
        );
        const justifiedAmountSigned = checkIfCloseToZero(
            bankTransaction.amount - notJustifiedAmountSigned,
        );
        await apollo.mutate({
            mutation: UPDATE_NOT_JUSTIFIED_AMOUNT,
            variables: {
                id: bankTransaction.id,
                notJustifiedAmountSigned,
                justifiedAmountSigned,
                updateAccountingLines: toUpdateAccountingLine ? [toUpdateAccountingLine] : [],
            },
        });
    }
}

async function addChatMessageIfNeccessary(
    apollo,
    userId,
    companyId,
    bankTransaction,
    reason,
    data,
) {
    if (!bankTransaction || bankTransaction.id) {
        return;
    }
    if (!reason) {
        debugger;
        return;
    }
    const message = reasons[reason];
    if (!message) {
        debugger;
        return;
    }
    if (bankTransaction.status === "INFORMATION_REQUEST") {
        data.status = "ANALYSED";
        const chatMessageData = {
            chatId: bankTransaction.chat ? bankTransaction.chat.id : undefined,
            companyId,
            userId,
            bankTransactionId: bankTransaction.id,
            message,
            chatType: "OBJECT",
        };
        await apollo.mutate({
            mutation: CREATE_MESSAGE,
            variables: chatMessageData,
        });
        // await createMessage(prisma, chatMessageData)
    }
}

// export async function validateIOPReconciliation(apollo, reconciliationId, accountingLines) {
//     const toDeleteAlIds = []
//     let bankTransactionId
//     let documentId
//     for (const al of accountingLines) {
//         // const al = item.accountingLine
//         if (al.id) {
//             toDeleteAlIds.push(al.id)
//         }
//         if (al.bankTransaction) {
//             if (bankTransactionId) {
//                 debugger // git-ignore
//                 return
//             }
//             bankTransactionId = al.bankTransaction.id
//         }
//         if (al.document) {
//             if (documentId) {
//                 debugger // git-ignore
//                 return
//             }
//             documentId = al.document.id
//         }
//     }
//     if (bankTransactionId && documentId) {
//         await apollo.mutate({
//             mutation: gql`
//                 mutation ValidateReconciliationIOP(
//                     $documentId: ID!
//                     $bankTransactionId: ID!
//                     $reconciliationId: ID!
//                     $toDeleteAlIds: [ID!]
//                 ) {
//                     validateReconciliationIOP(
//                         data: {
//                             documentId: $documentId
//                             bankTransactionId: $bankTransactionId
//                             reconciliationId: $reconciliationId
//                             toDeleteAlIds: $toDeleteAlIds
//                         }
//                     ) {
//                         status
//                     }
//                 }
//             `,
//             variables: {
//                 documentId,
//                 bankTransactionId,
//                 reconciliationId: reconciliationId,
//                 toDeleteAlIds
//             }
//         });
//     }
// }
